import { Component, inject } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { LocalisedDatePipe } from 'aih-launchpad-core';
import { Subscription } from 'rxjs';
import { PageTitleBarComponent } from "../page-title-bar/page-title-bar.component";

@Component({
  selector: 'app-desclaimer',
  imports: [
    TranslatePipe,
    LocalisedDatePipe,
    PageTitleBarComponent
],
  templateUrl: './disclaimer.component.html',
  styleUrl: './disclaimer.component.sass'
})
export class DisclaimerComponent {
  private translate = inject(TranslateService);

  private langSubscription?: Subscription;

  sections: Array<{title: string, content: string}> = [];

  lastUpdateDate = new Date('2025-11-28');

  ngOnInit() {
    this.loadSections();
    
    // Reload sections when language changes
    this.langSubscription = this.translate.onLangChange.subscribe(() => {
      this.loadSections();
    });
  }

  ngOnDestroy() {
    this.langSubscription?.unsubscribe();
  }

  loadSections() {
    this.translate.get('disclaimer.sections').subscribe(sections => {
      this.sections = sections;
    });
  }
}
